import { i18n } from "../i18n";
import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, Menu } from "./types";

const { t } = i18n.global;

function buildConfigSections(): ConfigSection[] {
  const sections: ConfigSection[] = [
    { component: "ConfSection", props: { name: "branch" } },
    { component: "ConfSection", props: { name: "basic" } },
    { component: "ConfSection", props: { name: "extended" } },
  ];

  return sections;
}

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const join = () => {
  window.open(t("ngp/settings/section/satisfactory_wiki/link"), "_blank", "noopener,noreferrer");
};

export default (): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections: buildConfigSections(),
  join: {
    buttonTextKey: "ngp/settings/section/satisfactory_wiki",
    joinFn: join,
  },
});
